const BUILD_VERSION = `${import.meta.env.VITE_BUILD_VERSION}`;
const API_URL = `${import.meta.env.VITE_API_URL}`;
const FRONT_URL = `${import.meta.env.VITE_FRONT_URL}`;
const APP_INSIGHTS_ID = `${import.meta.env.VITE_APP_INSIGHTS_ID || 'XXXXXXXX--XXXX-XXXX-XXXXXXXXXXXX'}`;
const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

const config = {
  BUILD_VERSION,
  API_URL,
  FRONT_URL,
  APP_INSIGHTS_ID,
  RECAPTCHA_SITE_KEY,
};

export default config;
